module.exports = __webpack_public_path__ + "static/media/unnamed_01.bcfca885.jpg";